import { useEffect } from 'react';

import { getTypeOrNull, useUsersQuery } from '@spotify/confidence-graphql';

// @internal
export const useUsers = () => {
  const { data, loading, fetchMore } = useUsersQuery({
    variables: { pageSize: 100 },
  });
  const userResponse = getTypeOrNull(data?.users);

  const { users = [], nextPageToken } = userResponse ?? {};

  useEffect(() => {
    if (nextPageToken) {
      fetchMore({
        variables: {
          pageToken: nextPageToken,
          pageSize: 100,
        },
      });
    }
  }, [nextPageToken, fetchMore]);

  return { users, loading };
};
